import Vue from 'vue'
export const EventBus = new Vue();
